import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/profile';
import axiosInstance from '@server/axiosInstance';
import { adminUpdateLogo } from '../api/constant';
import { adminEmployersList, adminEnterprisesList } from '../constants';

type useAdminUpdateProfileImageProps = {
  setAlertText?: Dispatch<SetStateAction<string>>;
};

export const useAdminUpdateProfileImage = ({
  setAlertText = () => { },
}: useAdminUpdateProfileImageProps) => {
  const client = useQueryClient();

  const { mutate: updateProfileImage, isLoading: isUpdatingProfileImage } =
    useMutation({
      mutationFn: (variables: {
        is_enterprise?: number;
        logo?: string;
        cover_image?: string
        social_image?: string
        user_Id: number
      }) =>
        axiosInstance.post(adminUpdateLogo, variables).then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setAlertText(data.message);
        } else {
          setAlertText('');
          client.invalidateQueries(adminEmployersList);
          client.invalidateQueries(adminEnterprisesList);
        }
      },
      onError: () => {
        setAlertText(errorMessage);
      },
    });

  return {
    updateProfileImage,
    isUpdatingProfileImage,
  };
};
